// extracted by mini-css-extract-plugin
module.exports = {"alignRight":"_bf110d94"};